import axios from 'axios';
import { Loading,Message } from 'element-ui';
import Router from '../router/index.js'
import { log, getUserId ,utils} from '@/common/common.js'

var baseUrl_jp ='http://10.10.1.111:10020'  //江鹏 
var baseUrl_sjr ='http://10.10.1.111:10020'  //宋佳融

var baseUrl_dev  ='https://api.dev.ysintelligent.com/yijiajia_admin/p/'  //dev
                   
var baseUrl_test ='https://api.test.ysintelligent.com/yijiajia_admin/p/'  //dev
var baseUrl      ='https://api.ysintelligent.com/yijiajia_admin/p/'

var imgPrev_dev='https://static.dev.ysintelligent.com'
var imgPrev_test='https://static.test.ysintelligent.com'
var imgPrev='https://static.ysintelligent.com'
//根据环境 改变接口地址 
var environmental=utils.getCurrentApi()
var resultApi={}
if(environmental=='dev'){
    resultApi={
    	baseUrl:baseUrl_dev,
    	imgPrev:imgPrev_dev
    } 
}
if(environmental=='test'){
    resultApi={
    	baseUrl:baseUrl_test,
    	imgPrev:imgPrev_test
    } 
}
if(environmental=='prod'){
    resultApi={
    	baseUrl:baseUrl,
    	imgPrev:imgPrev
    } 
}

export const api=resultApi
var instance = axios.create({
	baseURL: api.baseUrl,
	timeout: 200000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
export function ajaxPost(url, data) {
	let args={
        "functionSysId":utils.getSysId(),
        "functionAdminId":utils.getAdminId(),
        ...data
    }
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: url,
			data:args
		}).then(function(response) {
			// console.log(response,'response')
			if(!response.data.errorCode){
				Message({
					message: "返回数据格式异常",//接口返回一个页面
					type: 'error',
					duration: 1500
				});
			}else if(response.data.errorCode == -20000){
				Message({
					message: "token失效",
					type: 'error',
					duration: 1500
				});
			}else{
				if(response.data.errorCode == 200){
					
				}else{
					Message({
						message:response.data.errorMsg,
						type: 'error',
						duration: 1500
					});
				}
				
			}
			resolve(response.data)//resolve
		}).catch(function(response) {
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)//reject
		})
	})
	return p
	
}



// WEBPACK FOOTER //
// ./src/common/request.js